import React, { useState } from "react";
import Axios from "axios";

const zodiacSigns = [
  { en: "aries", th: "เมษ" },
  { en: "taurus", th: "พฤษภ" },
  { en: "gemini", th: "เมถุน" },
  { en: "cancer", th: "กรกฎ" },
  { en: "leo", th: "สิงห์" },
  { en: "virgo", th: "กันย์" },
  { en: "libra", th: "ตุล" },
  { en: "scorpio", th: "พิจิก" },
  { en: "sagittarius", th: "ธนู" },
  { en: "capricorn", th: "มังกร" },
  { en: "aquarius", th: "กุมภ์" },
  { en: "pisces", th: "มีน" },
];

export default function HoroscopeByZodiac() {
  const [result, setResult] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedZodiac, setSelectedZodiac] = useState(null); // ✅ เพิ่ม state นี้

  const getHoroscope = async (zodiac) => {
    try {
      setSelectedZodiac(zodiac); // ✅ เก็บ zodiac ที่เลือก

      // ✅ GTM Event เมื่อคลิกเลือกราศี
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "click_view_zodiac",
        zodiac_en: zodiac.en,
        zodiac_th: zodiac.th,
      });

      setLoading(true);
      const response = await Axios.post(
        `${process.env.REACT_APP_BIGC_BIGLINE_API_URL}/horoscope/get-zodiac-data`,
        { zodiac: zodiac.th },
        {
          headers: {
            "Content-Type": "application/json",
            "x-api-key": process.env.REACT_APP_BIGC_BIGLINE_API_KEY,
          },
        }
      );
      setResult(response.data?.data || "ไม่พบคำทำนาย");
      setModalOpen(true);
    } catch (error) {
      console.error("Error fetching horoscope:", error);
      setResult("เกิดข้อผิดพลาดในการดึงคำทำนาย");
      setModalOpen(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="border rounded p-4 mb-6 relative bg-white shadow">
      <h2 className="text-xl font-bold mb-3">🔮 ดูดวงตามราศี</h2>

      <div className="grid grid-cols-3 gap-3 mb-4">
        {zodiacSigns.map((z) => (
          <div
            key={z.en}
            className="cursor-pointer border border-gray-300 rounded-xl p-1 bg-gradient-to-b from-white to-purple-50 shadow-md transform transition duration-500 hover:scale-105 hover:shadow-[0_0_30px_rgba(168,85,247,0.6)] hover:border-purple-500 hover:brightness-110 hover:rotate-1"
            onClick={() => getHoroscope(z)}
          >
            <img
              src={`/images/zodiacThai/${z.en}.png`}
              alt={z.en}
              className="w-full h-auto rounded-md transition duration-500 ease-in-out"
            />
          </div>
        ))}
      </div>

      {/* Modal */}
      {modalOpen && selectedZodiac && (
        <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex justify-center z-50 p-2 pt-[5vh]">
          <div
            className="relative max-w-md w-full rounded-2xl shadow-2xl bg-cover bg-center"
            style={{
              backgroundImage: `url(/images/zodiacThai/${selectedZodiac.en}.png)`,
            }}
          >
            {/* overlay มัวพื้นหลัง เพื่อให้อ่านคำทำนายได้ */}
            <div className="absolute inset-0 bg-white bg-opacity-70 backdrop-blur-sm"></div>

            {/* เนื้อหา modal */}
            <div className="relative z-10 p-6 max-h-[75vh]">
              <button
                className="absolute top-2 right-2 text-gray-500 hover:text-red-500"
                onClick={() => setModalOpen(false)}
              >
                ❌
              </button>

              <h3 className="text-lg font-bold mb-2">
                🔮 คำทำนายราศี {selectedZodiac.th}
              </h3>

              {loading ? (
                <p>⏳ กำลังโหลด...</p>
              ) : (
                <div className="max-h-[75vh] overflow-y-auto pr-1">
                  <p className="whitespace-pre-wrap text-left">
                    {result?.horoscope || result}
                  </p>

                  <p className="text-xs text-gray-500 mt-4 text-left">
                    ⚠️ คำทำนายที่ปรากฏเป็นเพียงความเชื่อส่วนบุคคล
                    ใช้เพื่อความบันเทิงและแนะแนวเท่านั้น
                    ไม่ควรยึดถือเป็นข้อยุติหรือหลักในการตัดสินใจที่สำคัญในชีวิต
                    เช่น การงาน การเงิน สุขภาพ หรือความสัมพันธ์
                    ผู้ใช้งานควรใช้วิจารณญาณและพิจารณาจากสถานการณ์จริงร่วมด้วย
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
